// contentcomponent.ts
import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';
import { AuditService } from '../../services/audit.service';
import { AuthService } from '../../services/auth.service';
import { ActiveSectionStateService } from '../../services/active-session-state/active-section-state.service';
import { BackactionService } from '../../services/backaction.service';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss',
})
export class ContentComponent implements OnInit {
  userData: any = localStorage.getItem('auth_user');
  employeeName: any = this.userData ? JSON.parse(this.userData) : '';
  currentTime = moment().format('dddd, DD MMMM YYYY, hh:mm A');
  roleName: any = '';
  // this.employeeName.role == 3
  //   ? ' (HR)'
  //   : this.employeeName.role == 4
  //     ? ' (Employee)'
  //     : '';
  userLogo: string = this.employeeName.icon;
  breadcrumb = 'Dashboard';

  // lastLogin: any = moment().format('dddd, DD MMMM YYYY, hh:mm A');
  lastLogin: any = '';
  roleType: any;

  constructor(
    private readonly location: Location,
    private readonly modalService: NgbModal,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly auditService: AuditService,
    private readonly auth: AuthService,
    private readonly activeState: ActiveSectionStateService,
    private backActionService: BackactionService
  ) { }

  user: any;
  isShowWidget: boolean = false;
  hideBack = false;
  ngOnInit() {
    const previousUrl = this.router.lastSuccessfulNavigation?.previousNavigation?.finalUrl?.toString();
    const currentUrl = this.router.url;

    console.log('previousUrl', previousUrl);
    this.hideBack = this.shouldHideBack(previousUrl, currentUrl);

    this.getLastLogin();
    const data = localStorage.getItem('auth_user');

    if (data) {
      const parsedData = JSON.parse(data);
      this.roleType = parsedData?.role_type;
    }

    if (!localStorage.getItem('last_login_time')) {
      localStorage.setItem('last_login_time', this.currentTime);
    }

    let role: any = '';

    // Map Company breadcrumbs to Client breadcrumbs for role 1
    const clientBreadcrumbMap: Record<string, string> = {
      'Company List': 'Client List',
      'Add Company': 'Add Client',
      'Update Company': 'Update Client',
    };

    this.auth.user.subscribe((data) => {
      role = data.role;
      let breadcrumb = this.getBreadcrumb(this.activatedRoute.root);
      if (String(role) === '1' && clientBreadcrumbMap[breadcrumb]) {
        this.breadcrumb = clientBreadcrumbMap[breadcrumb];
      } else {
        this.breadcrumb = breadcrumb;
      }
      if (role == '2' || role == '1') {
        this.isShowWidget = true;
      }
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        let breadcrumb = this.getBreadcrumb(this.activatedRoute.root);
        if (String(role) === '1' && clientBreadcrumbMap[breadcrumb]) {
          this.breadcrumb = clientBreadcrumbMap[breadcrumb];
        } else {
          this.breadcrumb = breadcrumb;
        }
        this.hideBack = this.shouldHideBack(
          this.router.lastSuccessfulNavigation?.previousNavigation?.finalUrl?.toString(),
          this.router.url
        );
      });
  }

  private shouldHideBack(previousUrl: string | undefined, currentUrl: string): boolean {
    const noHistory = previousUrl === '/';
    const topLevelRoutes = [
      '/login',
      '/app/employee/employee-dashboard',
      // '/app/company/company-list',
      '/app/company',
    ];

    return noHistory || topLevelRoutes.includes(currentUrl);
  }

  getBreadcrumb(route: ActivatedRoute): string {
    let child = route;
    while (child.firstChild) {
      child = child.firstChild;
    }
    return child.snapshot.data['breadcrumb'];
  }

  goback() {
    const currentUrl = this.router.url;
    // console.log('currentUrl', currentUrl);
    if (currentUrl === '/app/master/paycomponent-master' || currentUrl === '/app/master/sponsor-create' || currentUrl === '/app/master/user-groups' || currentUrl === '/app/master/benefit-type/list' || currentUrl === '/app/master/loan-types-create' || currentUrl === '/app/master/loan-adjustment' || currentUrl === '/app/employee/task/list' || currentUrl === '/app/master/document-master') {

      if (this.backActionService.isFormActive) {
        this.backActionService.triggerCancel();
        return;
      }

      this.location.back();
      return;
    }

    const match = currentUrl.match(/company-list\/(\d+)/);
    // console.log('match', match);

    if (match) {
      const companyId = Number(match[1]);
      // console.log('Company ID:', companyId);

      const state = this.activeState.getState();
      // console.log('state', state);
      if (state == 'tax_settings') {
        this.activeState.setState('company_documents');
        this.activeState.emit({ type: 'company_documents', id: companyId });
      } else if (state == 'company_documents') {
        this.activeState.setState('company_parameters');
        this.activeState.emit({ type: 'company_parameters', id: companyId });
      } else if (state == 'company_parameters') {
        this.activeState.setState('company');
        this.activeState.emit({ type: 'company', id: companyId });
      } else if (state == 'company') {
        this.router.navigate(['/app/company/company-list/']);
      }
      else if (state == undefined) {
        this.router.navigate(['/app/company/company-list']);
      }
    } else {
      if (currentUrl == '/app/employee/employee-dashboard') {
        this.router.navigate(['/app/employee/employee-dashboard']);
      }
      else if (currentUrl == '/app/company') {
        this.router.navigate(['/app/company']);
      }
      else {
        this.location.back();
      }
    }
  }

  widgetSettings(content: any) {
    this.modalService.open(content, { size: 'lg' });
  }

  async getLastLogin() {
    const response: any = await lastValueFrom(this.auditService.getLastLogin());
    let createdAt = response?.data?.timestamp ?? '';
    this.lastLogin = createdAt
      ? moment(createdAt).format('dddd, DD MMMM YYYY, hh:mm A')
      : '';
  }
  goHome() {
    const role = this.roleType;
    if (role === 'employee') {
      this.router.navigate(['/app/employee/employee-dashboard']);
    } else if (role === 'super_user') {
      this.router.navigate(['/app/employee/employee-dashboard']);
    } else if (role === 'admin' || role === 'sub_admin') {
      this.router.navigate(['/app/company/company-list']);
    } else if (role === 'super_admin') {
      this.router.navigate(['/app/company/company-list']);
    }
  }

  clearform() {
    this.modalService.dismissAll();
  }
}
